
        import * as THREE from 'three';

        (function () {
            const container = document.getElementById('antigravity-canvas');
            if (!container) return;

            // Config
            const COUNT = 800;
            const MAGNET_RADIUS = 8;
            const RING_RADIUS = 6;
            const WAVE_SPEED = 0.4;
            const WAVE_AMPLITUDE = 1;
            const PARTICLE_SIZE = 0.30;
            const LERP_SPEED = 0.07;
            // Logo palette: muted purple, blue, cyan, teal, green, yellow, orange, pink/red
            const COLORS = ['#6D4BB0', '#4F52C8', '#2D6ED4', '#0593AA', '#0D916B', '#6BA614', '#C47D08', '#C75A10', '#BB3580', '#C73535'];
            const AUTO_ANIMATE = true;
            const PARTICLE_VARIANCE = 1;
            const ROTATION_SPEED = 0;
            const DEPTH_FACTOR = 1;
            const PULSE_SPEED = 3;
            const FIELD_STRENGTH = 10;

            // Scene setup
            const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setClearColor(0x000000, 0);
            container.appendChild(renderer.domElement);

            const scene = new THREE.Scene();
            const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 1000);
            camera.position.set(0, 0, 50);

            function resize() {
                const w = container.clientWidth;
                const h = container.clientHeight;
                renderer.setSize(w, h);
                camera.aspect = w / h;
                camera.updateProjectionMatrix();
            }
            resize();
            window.addEventListener('resize', resize);

            // Viewport size in world units
            function getViewport() {
                const vFov = (camera.fov * Math.PI) / 180;
                const height = 2 * Math.tan(vFov / 2) * camera.position.z;
                const width = height * camera.aspect;
                return { width, height };
            }

            // Particles
            const dummy = new THREE.Object3D();
            const vp = getViewport();

            const particles = [];
            for (let i = 0; i < COUNT; i++) {
                const x = (Math.random() - 0.5) * vp.width;
                const y = (Math.random() - 0.5) * vp.height;
                const z = (Math.random() - 0.5) * 20;
                particles.push({
                    t: Math.random() * 100,
                    speed: 0.01 + Math.random() / 200,
                    mx: x, my: y, mz: z,
                    cx: x, cy: y, cz: z,
                    randomRadiusOffset: (Math.random() - 0.5) * 2
                });
            }

            // Instanced mesh — capsule-like: use CapsuleGeometry if available, else cylinder
            let geo;
            if (THREE.CapsuleGeometry) {
                geo = new THREE.CapsuleGeometry(0.1, 0.4, 4, 8);
            } else {
                geo = new THREE.CylinderGeometry(0.1, 0.1, 0.5, 8);
            }
            const mat = new THREE.MeshBasicMaterial({ vertexColors: false });
            mat.color = new THREE.Color(0xffffff);
            const mesh = new THREE.InstancedMesh(geo, mat, COUNT);
            mesh.instanceColor = new THREE.InstancedBufferAttribute(new Float32Array(COUNT * 3), 3);
            // Assign a random logo color to each particle
            const _c = new THREE.Color();
            for (let i = 0; i < COUNT; i++) {
                _c.set(COLORS[Math.floor(Math.random() * COLORS.length)]);
                mesh.setColorAt(i, _c);
            }
            mesh.instanceColor.needsUpdate = true;
            scene.add(mesh);

            // Mouse tracking
            const mouse = { x: 0, y: 0 };
            const virtualMouse = { x: 0, y: 0 };
            const lastMousePos = { x: 0, y: 0 };
            let lastMouseMoveTime = 0;

            document.addEventListener('mousemove', (e) => {
                const rect = container.getBoundingClientRect();
                // Normalized -1 to +1
                mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
                mouse.y = -(((e.clientY - rect.top) / rect.height) * 2 - 1);
                const dist = Math.hypot(mouse.x - lastMousePos.x, mouse.y - lastMousePos.y);
                if (dist > 0.001) {
                    lastMouseMoveTime = Date.now();
                    lastMousePos.x = mouse.x;
                    lastMousePos.y = mouse.y;
                }
            });

            const clock = new THREE.Clock();

            function animate() {
                requestAnimationFrame(animate);

                // Re-read viewport in case of resize
                const vp2 = getViewport();

                let destX = (mouse.x * vp2.width) / 2;
                let destY = (mouse.y * vp2.height) / 2;

                const elapsed = clock.getElapsedTime();

                if (AUTO_ANIMATE && Date.now() - lastMouseMoveTime > 2000) {
                    destX = Math.sin(elapsed * 0.5) * (vp2.width / 4);
                    destY = Math.cos(elapsed * 0.5 * 2) * (vp2.height / 4);
                }

                virtualMouse.x += (destX - virtualMouse.x) * 0.05;
                virtualMouse.y += (destY - virtualMouse.y) * 0.05;

                const targetX = virtualMouse.x;
                const targetY = virtualMouse.y;
                const globalRotation = elapsed * ROTATION_SPEED;

                for (let i = 0; i < COUNT; i++) {
                    const p = particles[i];
                    p.t += p.speed / 2;
                    const t = p.t;

                    const projFactor = 1 - p.cz / 50;
                    const projX = targetX * projFactor;
                    const projY = targetY * projFactor;

                    const dx = p.mx - projX;
                    const dy = p.my - projY;
                    const dist = Math.hypot(dx, dy);

                    let tx = p.mx, ty = p.my, tz = p.mz * DEPTH_FACTOR;

                    if (dist < MAGNET_RADIUS) {
                        const angle = Math.atan2(dy, dx) + globalRotation;
                        const wave = Math.sin(t * WAVE_SPEED + angle) * (0.5 * WAVE_AMPLITUDE);
                        const deviation = p.randomRadiusOffset * (5 / (FIELD_STRENGTH + 0.1));
                        const r = RING_RADIUS + wave + deviation;
                        tx = projX + r * Math.cos(angle);
                        ty = projY + r * Math.sin(angle);
                        tz = p.mz * DEPTH_FACTOR + Math.sin(t) * (WAVE_AMPLITUDE * DEPTH_FACTOR);
                    }

                    p.cx += (tx - p.cx) * LERP_SPEED;
                    p.cy += (ty - p.cy) * LERP_SPEED;
                    p.cz += (tz - p.cz) * LERP_SPEED;

                    dummy.position.set(p.cx, p.cy, p.cz);
                    dummy.lookAt(projX, projY, p.cz);
                    dummy.rotateX(Math.PI / 2);

                    const dFromRing = Math.abs(Math.hypot(p.cx - projX, p.cy - projY) - RING_RADIUS);
                    let scaleFactor = Math.max(0, Math.min(1, 1 - dFromRing / 10));
                    const finalScale = scaleFactor * (0.8 + Math.sin(t * PULSE_SPEED) * 0.2 * PARTICLE_VARIANCE) * PARTICLE_SIZE;
                    dummy.scale.set(finalScale, finalScale, finalScale);
                    dummy.updateMatrix();
                    mesh.setMatrixAt(i, dummy.matrix);
                }

                mesh.instanceMatrix.needsUpdate = true;
                renderer.render(scene, camera);
            }

            animate();
        })();
    